@if (!isTableOnDialog) {
    <div>
        <ng-container *ngTemplateOutlet="tableTemplate">
        </ng-container>
    </div>
}

<ng-template #tableTemplate>
    @if (_buttons) {
        <app-button-bar [setButtons]="_buttons" [items]="highlightedRowsCopy" [className]="buttonBarClassName"
                        (buttonEmit)="buttonEmit($event.name)"></app-button-bar>
    }
    <div cdkDropListGroup class="table-wrapper">

        @if (allowFilter) {
            <div style="position: relative; text-align: left;">
                @if (showFilter) {
                    <mat-icon class="search" (click)="toggleFilter()">search_off</mat-icon>
                }
                @if (!showFilter && !expandableEditor) {
                    <mat-icon class="search" (click)="toggleFilter()">search</mat-icon>
                }
                @if (showFilter) {
                    <mat-form-field class="searchWrap">
                        <mat-label>{{ 'placeholder.filterList' | transloco }}</mat-label>
                        <input matInput type="text" (keyup)="applyFilter($event.target['value'])" [(ngModel)]="filter"
                               autocomplete="off" />
                        <a matSuffix aria-label="Clear" (click)="clearFilter()">
                            <mat-icon>close</mat-icon>
                        </a>
                    </mat-form-field>
                }
            </div>
        }

        @if (!expandableEditor) {
            <div class="table-content">
                <table mat-table id="bb" #dtable [dataSource]="dataSource" [ngClass]="tableClassName"
                       class="matTableMaxSpace mat-elevation-z8 example-container drop-table-area"
                       [cdkDropListDisabled]="disableDrag"
                       cdkDropList [cdkDropListData]="dataSource"
                       (cdkDropListDropped)="drop($event)">
                    @for (col of tableColumn; track col; let index = $index) {
                        <ng-container class="dragCursor" matColumnDef="{{col.name}}">
                            <th class="tableHeader" [resizeColumn]="true" mat-header-cell
                                *matHeaderCellDef>{{ col.label || col.name }}
                            </th>
                            <td mat-cell class="textAlignLeft tableListItems" *matCellDef="let element;">
                                <!-- ** edit per column or edit per value examples ** -->
                                <!--   <editable *ngIf="col.name === 'page'; else elseBlock" (update)="updateField($event, element, null)"> -->
                                <!--   <editable *ngIf="element.$.page === 'BB'; else elseBlock" (update)="updateField($event, element, null)"> -->
                                <div>
                                    @switch (col.inputType) {
                                        @case ('edit-button') {
                                            <div>
                                                <!--                        <a style="width: 180px" mat-raised-button (click)="callBackAction($event)">-->
                                                <editable (update)="updateField($event, element, col.name)">
                                                    <ng-template viewMode>
                                                        @if (callBackFaIcon) {
                                                            <span>
                                                                <fa-icon class="itemIcon"
                                                                        [icon]="element | tableListIconPipe:[element, callBackFaIcon, index]"></fa-icon>
                                                            </span>
                                                        }{{element.$[col.name] | PipeTruncate:[col.maxStringSize]}}
                                                        @if (!disableDrag && index === tableColumn.length - 1 && !draggingNow) {
                                                            <span class="drgIcon">
                                                                <mat-icon>drag_indicator</mat-icon>
                                                            </span>
                                                        }
                                                    </ng-template>
                                                    <ng-template editMode>
                                                        <!-- <input #editInput focusable [value]="element.$[col.name]" [ngStyle]="{'width.%': 120 / tableColumn.length}"> -->
                                                        <input inputrestriction="basic0" min="1"
                                                               type="{{inputEditFormat[col.name]}}" #editInput value=""
                                                               [ngModel]="element.$[col.name]"
                                                               [ngStyle]="{'width.%': (tableColumn.length === 1 ? 80 : (tableColumn.length === 2 ? 90 : 220 / tableColumn.length))}">
                                                    </ng-template>
                                                </editable>
                                                <a (click)="onButtonEditClicked($event, col.name)" mat-icon-button
                                                   class="edit-icon" style="display: none;">
                                                    <mat-icon>attach_file</mat-icon>
                                                </a>
                                            </div>
                                        }
                                        @case ('edit') {
                                            <div>
                                                <editable>
                                                    <ng-template viewMode>
                                                        @if (callBackFaIcon) {
                                                            <span>
                                                                <fa-icon class="itemIcon"
                                                                        [icon]="element | tableListIconPipe:[element, callBackFaIcon, index]"></fa-icon>
                                                            </span>
                                                        }{{element.$[col.name] | PipeTruncate:[col.maxStringSize]}}
                                                        @if (!disableDrag && index === tableColumn.length - 1 && !draggingNow) {
                                                            <span class="drgIcon">
                                                                <mat-icon>drag_indicator</mat-icon>
                                                            </span>
                                                        }
                                                    </ng-template>
                                                    <ng-template editMode>
                                                        <!-- <input #editInput focusable [value]="element.$[col.name]" [ngStyle]="{'width.%': 120 / tableColumn.length}"> -->
                                                        <input inputrestriction="basic0"
                                                               type="{{inputEditFormat[col.name]}}" #editInput focusable
                                                               value="" [ngModel]="element.$[col.name]"
                                                               [ngStyle]="{'width.%': 100}">
                                                        <!-- (tableColumn.length === 1 ? 80 : (tableColumn.length === 2 ? 90 : 250 / tableColumn.length)) -->
                                                        <a (click)="updateField(editInput.value, element, col.name)"
                                                           mat-icon-button>
                                                            <mat-icon
                                                                style="font-size: 15px !important; width: 24px; height: 24px; line-height: 24px;"
                                                                matTooltip="{{'general.save' | transloco}}">done_all
                                                            </mat-icon>
                                                        </a>
                                                    </ng-template>
                                                </editable>
                                            </div>
                                        }
                                        @case ('text') {
                                            <div>
                                                @if (callBackFaIcon) {
                                                    <span>
                                                        <fa-icon class="itemIcon"
                                                                [icon]="element | tableListIconPipe:[element, callBackFaIcon, index]"></fa-icon>
                                                    </span>
                                                }{{element.$[col.name] | PipeTruncate:[col.maxStringSize]}}
                                                @if (!disableDrag && index === tableColumn.length - 1 && !draggingNow) {
                                                    <span class="drgIcon">
                                                        <mat-icon>drag_indicator</mat-icon>
                                                    </span>
                                                }
                                            </div>
                                        }
                                        @case ('select') {
                                            <div>
                                                {{element.$[col.name] | PipeTruncate:[col.maxStringSize]}}
                                                <mat-select (click)="$event.stopPropagation()"
                                                            [(value)]="col.selectValue">
                                                    @for (i of col.selectValues; track i) {
                                                        <mat-option [value]="i">
                                                            {{ i | PipeTruncate:[col.maxStringSize] }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </div>
                                        }
                                        @default {
                                            <div> error no type configured</div>
                                        }
                                    }
                                </div>
                            </td>
                        </ng-container>
                    }
                    <tr mat-header-row class="dragCursor textAlignLeft"
                        *matHeaderRowDef="tableColumnNames; sticky: true"></tr>
                    <tr mat-row (click)="onSelectedRow(row)"
                        class="dragCursor textAlignLeft" [ngClass]="{'selected': highlightedRows.indexOf(row) > -1}"
                        *matRowDef="let row; columns: tableColumnNames;"
                        (cdkDragStarted)="dragStarted($event)" (cdkDragEnded)="dragEnded($event)" cdkDrag
                        [cdkDragData]="row"
                        [style.background]="highlightedRows.indexOf(row) > -1 ? 'var(--background-default2)' : ''">
                        <div *cdkDragPreview class=""
                             [ngStyle]="{'width.px': 280, 'height.px': 40, 'background-color': 'var(--background-default2)'}">
                            <div style="padding-left: 30px; padding-top: 10px">
                                <fa-icon class="itemIcon pull-right" [icon]="faArrowsAlt"></fa-icon>
                                {{ row.$.page }}
                            </div>
                        </div>
                    </tr>
                </table>
            </div>
        }

        @if (expandableEditor) {
            <div class="table-content">
                <table mat-table id="bb" #dtable multiTemplateDataRows [ngClass]="tableClassName"
                       [dataSource]="dataSource"
                       class="matTableMaxSpace mat-elevation-z8 example-container drop-table-area"
                       [cdkDropListDisabled]="disableDrag"
                       cdkDropList [cdkDropListData]="dataSource"
                       (cdkDropListDropped)="drop($event)">
                    @for (col of tableColumn; track col; let index = $index) {
                        <ng-container class="dragCursor" matColumnDef="{{col.name}}">
                            <th class="tableHeader" [resizeColumn]="true" mat-header-cell
                                *matHeaderCellDef>{{ col.label || col.name }}
                            </th>
                            <td mat-cell class="textAlignLeft tableListItems" *matCellDef="let element;">
                                <div class="d-flex-center">
                                    @if (!disableDrag && index === 0 && !draggingNow) {
                                        <mat-icon class="drgIcon1">drag_indicator</mat-icon>
                                    }
                                    @if (callBackFaIcon) {
                                        <fa-icon class="itemIcon"
                                                 [icon]="element | tableListIconPipe:[element, callBackFaIcon, index]"></fa-icon>
                                    }
                                    @if (col.inputType === 'color') {
                                        <div class="color-preview-container" (click)="$event.stopPropagation()">
                                            <div class="color-preview-box"
                                                 [style.background-color]="decimalToHex(element.$[col.name])"
                                                 (click)="colorInput.click(); $event.stopPropagation()"
                                                 [matTooltip]="'Click to change color'">
                                            </div>
                                            <input #colorInput
                                                   type="color"
                                                   class="color-input-hidden"
                                                   [value]="decimalToHex(element.$[col.name])"
                                                   (input)="element.$[col.name] = hexToDecimal($any($event.target).value); $event.stopPropagation()"
                                                   (change)="updateField(hexToDecimal($any($event.target).value), element, col.name); $event.stopPropagation()"
                                                   (click)="$event.stopPropagation()"
                                                   (mousedown)="$event.stopPropagation()">
                                        </div>
                                    } @else {
                                        <span
                                            class="col-text"
                                            [ngClass]="{
                                                'dynamic': col.inputType !== 'fixed' && col.inputType !== 'number',
                                                'last-col': editable && index === tableColumn.length - 1,
                                                'short-col': !disableDrag && index === 0 && !draggingNow
                                            }">{{element.$[col.name] || '...'}}</span>
                                    }
                                    @if (editable && index === tableColumn.length - 1 && !draggingNow && expandedElement != element) {
                                        <span class="drgIcon"
                                              (click)="expandedElement = element;">
                                            <mat-icon matTooltip="{{'general.edit' | transloco}}"
                                                    [ngStyle]="{'color': 'var(--background-green)'}">
                                                edit
                                            </mat-icon>
                                        </span>
                                    }
                                </div>
                            </td>
                        </ng-container>
                    }
                    <ng-container matColumnDef="expandedPanel">
                        <td mat-cell *matCellDef="let element" [attr.colspan]="tableColumnNames.length"
                            style="padding-right: 0;" [ngClass]="{'expanded': element == expandedElement}">
                            @if (element == expandedElement) {
                                <div class="edit-panel-wrapper"
                                     [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                                    <div class="edit-panel">
                                        @for (col of tableColumn; track col; let index = $index) {
                                            @if (col.inputType !== 'select' && col.inputType !== 'color' && col.inputType !== 'text' && col.inputType !== 'fixed') {
                                                <div>
                                                    <mat-form-field style="width: 80%;">
                                                        <mat-label>{{ col.label || col.name }}</mat-label>
                                                        <input matInput inputrestriction="basic0"
                                                               type="{{inputEditFormat[col.name]}}"
                                                               [value]="element.$[col.name]"
                                                               (keydown.enter)="updateField($event.target['value'], element, col.name, true)"
                                                               (blur)="updateField($event.target['value'], element, col.name)">
                                                    </mat-form-field>
                                                    @if (col.inputType === 'edit-button' && callBackEditIcon) {
                                                        <a (click)="onButtonEditClicked(element, col.name)"
                                                           mat-icon-button class="edit-icon mini-button">
                                                            <fa-icon
                                                                [icon]="element | tableListIconPipe:[element, callBackEditIcon, index]"></fa-icon>
                                                        </a>
                                                    }
                                                </div>
                                            }
                                            @if (col.inputType === 'select') {
                                                <div>
                                                    <mat-form-field style="width: 80%;">
                                                        <mat-label>{{ col.label || col.name }}</mat-label>
                                                        <mat-select
                                                            (selectionChange)="updateField($event.value, element, col.name)"
                                                            [(value)]="element.$[col.name]">
                                                            @for (i of col.selectValues; track i) {
                                                                <mat-option [value]="i">{{ i }}</mat-option>
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            }
                                        }
                                    </div>
                                    <button mat-icon-button class="icon-edit-done mini-button"
                                            (mousedown)="collapseEditor()">
                                        <mat-icon
                                            [ngStyle]="{'color': 'var(--background-green)'}"
                                            style="font-size: 18px !important;"
                                            matTooltip="{{'general.save' | transloco}}">
                                            check
                                        </mat-icon>
                                    </button>
                                </div>
                            }
                        </td>
                    </ng-container>
                    <tr mat-header-row class="dragCursor textAlignLeft"
                        *matHeaderRowDef="tableColumnNames; sticky: true"></tr>
                    <!-- (click)="expandedElement = expandedElement === element ? null : element" -->
                    <tr mat-row
                        *matRowDef="let row; columns: tableColumnNames;"
                        class="dragCursor textAlignLeft" [ngClass]="{'selected': highlightedRows.indexOf(row) > -1}"
                        (cdkDragStarted)="dragStarted($event)" (cdkDragEnded)="dragEnded($event)" cdkDrag
                        [cdkDragData]="row"
                        [style.background]="highlightedRows.indexOf(row) > -1 ? 'var(--background-default2)' : ''"
                        [class.example-expanded-row]="expandedElement === row"
                        (click)="onSelectedRow(row)">
                        <div *cdkDragPreview class=""
                             [ngStyle]="{'width.px': 280, 'height.px': 40, 'background-color': 'var(--background-default2)'}">
                            <div style="padding-left: 30px; padding-top: 10px">
                                <fa-icon class="itemIcon pull-right" [icon]="faArrowsAlt"></fa-icon>
                                {{ row.$.page }}
                            </div>
                        </div>
                    </tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedPanel']" class="edit-panel-row"></tr>
                </table>
            </div>
        }
        @if (enablePagination) {
            <mat-paginator class="mini-paginator"
                           [pageSize]="pageSize"
                           [pageSizeOptions]="pageSizeOptions"
                           showFirstLastButtons>
            </mat-paginator>
        }
    </div>
</ng-template>

<ng-template let-modal #tableModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">list</mat-icon>
        <span class="section-title">{{ 'general.list' | transloco }}</span>
        <button mat-icon-button class="close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <ng-container *ngTemplateOutlet="tableTemplate"></ng-container>
    </div>
</ng-template>
